/**
 * Бейдж типа заказа: B2B (дилер, company) | Физлицо (B2C, individual).
 * Делает тип заказа явным в карточке, списке и канбане.
 */
import { useTranslation } from 'react-i18next'

export function OrderKindBadge({
  kind,
}: {
  kind?: 'company' | 'individual' | null
}) {
  const { t } = useTranslation()
  const individual = kind === 'individual'
  return (
    <span
      className={
        'inline-flex shrink-0 items-center rounded-[100px] border px-2 py-0.5 ' +
        'text-[length:var(--stryzh-font-size-xs)] font-medium ' +
        (individual
          ? 'border-[color:var(--stryzh-color-accent-orange)] text-[color:var(--stryzh-color-accent-orange)]'
          : 'border-[color:var(--stryzh-color-border-default)] text-[color:var(--stryzh-color-text-secondary)]')
      }
      title={individual ? t('orderKind.individualTitle') : t('orderKind.b2bTitle')}
    >
      {individual ? t('orderKind.individual') : t('orderKind.b2b')}
    </span>
  )
}
